export default "__VITE_ASSET__9wGT$3iB__"